import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AgreementResponseModel } from "@fs/models/agreement/response.model";
import { AgreementVisitModel } from "@fs/models/agreement/visit.model";
import { FsUtil } from "./fs-utils";

export class FormInit {
    constructor(){
    }

    public ServiceAgreementForm(val: AgreementResponseModel): FormGroup {
        return new FormGroup({
            ID: new FormControl(val.ID),
            EffectiveDate: new FormControl({ value: new Date().getDateFromString(val.EffectiveDate), disabled: val.ID!="" }, Validators.required),
            ExpirationDate: new FormControl({ value: new Date().getDateFromString(val.ExpirationDate), disabled: true }),
            Note: new FormControl(val.Note, Validators.maxLength(1024)),
            Equipments: new FormControl([])
        });
    }

    public VisitForm(val: AgreementVisitModel): FormGroup {
        let disabled = val.ProposedDate == "" || !FsUtil.checkNullOrUndefined([val.WorkTicketID], true);

        return new FormGroup({
            ID: new FormControl(val.ID),
            ProposedDate: new FormControl({ value: new Date().getDateFromString(val.ProposedDate), disabled: (val.ProposedDate == "") ? false : disabled }, Validators.required),
            FollowupDate: new FormControl({ value: new Date().getDateFromString(val.FollowupDate), disabled: disabled }, Validators.required),
            ServiceTypeID: new FormControl({ value: val.ServiceTypeID, disabled: disabled }, Validators.required),
            WorkTicketID: new FormControl(val.WorkTicketID),
            WoNumber: new FormControl(val.WoNumber),
            PromisedDate: new FormControl(val.PromisedDate),
            IsAdhoc: new FormControl(val.IsAdhoc),
            DispatchComment: new FormControl({ value: val.DispatchComment, disabled: disabled }, Validators.maxLength(1024)),
            ServiceType: new FormControl(val.ServiceType)
        });
    }
}